import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { Roles } from '@core/helpers/all-roles';
import { TenantService } from '@core/tenant/tenant.service';
import { NgxPermissionsService } from 'ngx-permissions';
import { Observable } from 'rxjs';


@Injectable({
  providedIn: 'root'
})
export class SearchRedirectGuard implements CanActivate {
    constructor(
    private tenantService: TenantService,
    private router: Router
  ) { }

    canActivate(route: ActivatedRouteSnapshot,): boolean {
      const currentPath = route.routeConfig?.path;
      const queryParams = route.queryParams;

      if(this.tenantService.currentTenant.clinicSearchAccess && currentPath === 'search') {
        this.router.navigate(['/clinic-search'], { queryParams });
        return false;
      }
      
      if(!this.tenantService.currentTenant.clinicSearchAccess && currentPath === 'clinic-search') {
        this.router.navigate(['/search'], { queryParams });
        return false;
      }

    return true;
  }
}